import React from "react";
import { InvoiceCaptureTable } from "./view/InvoiceCaptureTable";

interface Props {}

export const InvoiceCapture: React.FC<Props> = () => {
  return (
    <>
      <InvoiceCaptureTable />
    </>
  );
};
